import dayjs from 'dayjs'
import { formatDate } from '../../utils/common'
import { IntakeCardProps } from './IntakeCard'
import { IntakeField } from './_styles'

export const ApplicationPeriod = ({ intake, type }: IntakeCardProps) => {
  const { applicationAllowStartDate, applicationAllowEndDate } = intake

  let str = ''

  if (dayjs(applicationAllowEndDate).isBefore(dayjs())) {
    str = 'Closed'
  } else if (applicationAllowStartDate && dayjs(applicationAllowStartDate).isAfter(dayjs())) {
    str = `From ${formatDate(applicationAllowStartDate)}`
    if (applicationAllowEndDate) {
      str = `${str} - To ${formatDate(applicationAllowEndDate)}`
    }
  } else {
    str = `Open`
  }

  return (
    <div className="app-period">
      {type ? (
        <IntakeField>
          <span> Application Period</span> {str}
        </IntakeField>
      ) : (
        <>
          <label>
            <b> Application Period</b>
          </label>
          <label> {str}</label>
        </>
      )}
    </div>
  )
}
